<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
				<template>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="客户" class="mb-0">
							<el-select v-model="from.name" size="small" clearable filterable :placeholder="$t('system.select')">
								<el-option v-for="item in agentData.user" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item :label="$t('accountList.ac_id')" class="mb-0">
							<el-input size="small" v-model="from.ac_id"></el-input>
						</el-form-item>
						<el-form-item :label="$t('adminList.loginName')" class="mb-0">
							<el-input size="small" v-model="from.username"></el-input>
						</el-form-item>	
						
						
						
						<el-form-item :label="$t('accountList.parentID')" class="mb-0">
							<el-input size="small"  v-model="from.parentID"></el-input>
						</el-form-item>
						<el-form-item :label="$t('accountList.parent')" class="mb-0">
							<el-input size="small"  v-model="from.parentAcid"></el-input>
						</el-form-item>
						
						
						
						<el-form-item :label="$t('accountList.type')" class="mb-0">
							<el-select v-model="from.type" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('accountList.type1')" :value="1"></el-option>
								<el-option :label="$t('accountList.type2')" :value="2"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item :label="$t('accountList.isFp')" class="mb-0">
							<el-select v-model="from.status" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('accountList.yes')" :value="1"></el-option>
								<el-option :label="$t('accountList.no')" :value="0"></el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item :label="$t('accountList.getType')" class="mb-0">
							<el-select v-model="from.get_status" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('accountList.noGet')" :value="0"></el-option>
								<el-option :label="$t('accountList.yesGet')" :value="1"></el-option>
								<el-option :label="$t('accountList.expireGet')" :value="2"></el-option>
								
							</el-select>
						</el-form-item>
						
						<el-form-item :label="$t('accountList.account_status')" class="mb-0">
							<el-select v-model="from.account_status" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('accountList.zc')" :value="1"></el-option>
								<el-option :label="$t('accountList.yc')" :value="0"></el-option>
								<el-option :label="$t('accountList.dy')" :value="2"></el-option>
								<el-option :label="$t('accountList.zf')" :value="3"></el-option>
								
							</el-select>
						</el-form-item>
						<el-form-item :label="$t('accountList.cloudName')" class="mb-0">
							<el-select v-model="from.cloud_id" size="small" filterable :placeholder="$t('system.select')">
								<el-option  :label="$t('status.all')" :value="-1">
								</el-option>
								<el-option v-for="item in agentData.cloud" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item label="供应商" class="mb-0">
							<el-select v-model="from.supplier_id" size="small" filterable :placeholder="$t('system.select')">
								<el-option  :label="$t('status.all')" :value="-1">
								</el-option>
								<el-option v-for="item in agentData.provider_supplier" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						
						<el-form-item :label="$t('new1.sup')" class="mb-0">
							<el-select v-model="from.sup_id" size="small" filterable :placeholder="$t('system.select')">
								<el-option  :label="$t('status.all')" :value="-1">
								</el-option>
								<el-option v-for="item in agentData.sup" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item :label="$t('adminList.createTime')"  class="mb-0">
							 <el-date-picker
							      size="small"
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      :range-separator="$t('system.to')"
							      :start-placeholder="$t('system.startTime')"
							      :end-placeholder="$t('system.endTime')"
							      >
							    </el-date-picker>
						</el-form-item>
						
						<el-form-item class="mb-0">
						<el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
							<el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
						</el-form-item>
				
					</el-form>
					<div style="margin-top:10px">
						<el-button size="small" type="primary" v-if="layout.user.type==1" @click="openModel(false)" v-auth="'add'+auth_val" >{{$t('accountList.addAccount')}}</el-button>
						<el-button size="small" type="warning" plain v-if="layout.user.type==1" @click="openProviderSupplierManage">供应商管理</el-button>
						<el-button size="small" type="info" plain v-if="layout.user.type==1" @click="openSubSupplierManage">子供应商管理</el-button>
						<el-button size="small" type="success" icon="el-icon-download" v-if="layout.user.type==1" :loading="accountExcelLoading" @click="downAccountExcel">导出Excel</el-button>
					</div>
			</template>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2" style="padding-bottom:20px">
			<el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
				<!-- <el-table-column align="center" type="index" :label="$t('adminList.sort')" width="50">
				</el-table-column> -->
				
				<el-table-column fixed="left" align="center" prop="id"  :label="$t('userList.id')" width="60">
				</el-table-column>
				<!-- <el-table-column align="center" prop="name" width="50" :label="$t('adminList.avatar')">
					<template slot-scope="scope">
						<el-image 
							style="width: 40px; height: 40px"
							:src="scope.row.head" 
							:preview-src-list="check_img_list">
						</el-image>
					</template>
				</el-table-column> -->
				
				<el-table-column width="130" align="center" prop="cloud_name" :label="$t('accountList.cloudName')" show-overflow-tooltip class-name="account-provider-nowrap">
				</el-table-column>
				
				<el-table-column width="130" align="center" prop="provider_supplier_name" label="供应商" show-overflow-tooltip class-name="account-provider-nowrap">
				</el-table-column>
				
				<el-table-column width="100" align="center" prop="sup_name" :label="$t('new1.sup')">
				</el-table-column>
				
				<el-table-column align="center" width="200" prop="ac_id" :label="$t('accountList.ac_id')">
					<template slot-scope="scope">
					<el-tooltip class="item" effect="light" :content="scope.row.ac_id" placement="top" >
					  <span class="ellipsis-text">{{ scope.row.ac_id }}</span>
					 
					</el-tooltip>
					
					
					<span class="iconCopy" @click="copyText(scope.row.ac_id)"><i class="iconfont icon-fuzhi"></i></span>
					</template>
				</el-table-column>
				<el-table-column align="center" width="200" prop="username" :label="$t('adminList.loginName')">
					<template slot-scope="scope">
					<el-tooltip class="item" effect="light" :content="scope.row.username" placement="top" >
					  <span class="ellipsis-text">{{ scope.row.username }}</span>
					 
					</el-tooltip>
					
					
					<span class="iconCopy" @click="copyText(scope.row.username)"><i class="iconfont icon-fuzhi"></i></span>
					</template>
				</el-table-column>
				
				<el-table-column v-if="layout.user.type==1" align="center" width="140" prop="password" :label="$t('adminList.loginPassword')">
					<template slot-scope="scope">
						<span>{{scope.row.showPass==1?scope.row.password:scope.row.password2}}</span> <i class="el-icon-view ml-1" @click="changePassShow(scope.row)"></i>
						
						<span class="iconCopy" @click="copyText(scope.row.password)"><i class="iconfont icon-fuzhi"></i></span>
					</template>
				</el-table-column>
				
				
				
				
				
				
				
				<el-table-column v-if="layout.user.type==1" align="center" width="140" prop="password" :label="$t('accountList.email_pass')">
					<template slot-scope="scope">
						
						<span>{{scope.row.showPassEmail==1?scope.row.email_pass:scope.row.email_pass2}}</span> <i class="el-icon-view ml-1" @click="changePassShowEmail(scope.row)"></i>
						
						<span class="iconCopy" @click="copyText(scope.row.email_pass)"><i class="iconfont icon-fuzhi"></i></span>
					</template>
				</el-table-column>
				
				
				<el-table-column align="center" width="200" prop="other_id" :label="$t('accountList.other_id')">
					<template slot-scope="scope">
					<el-tooltip class="item" effect="light" :content="scope.row.other_id" placement="top" >
					  <span class="ellipsis-text">{{ scope.row.other_id }}</span>
					 
					</el-tooltip>
					
					
					<span class="iconCopy" @click="copyText(scope.row.other_id)"><i class="iconfont icon-fuzhi"></i></span>
					</template>
				</el-table-column>
				
				
				<el-table-column align="center" prop="type" :label="$t('accountList.type')">
					<template slot-scope="scope">
						
						<span class="text-info" v-if="scope.row.type==1">{{$t('accountList.type1')}}</span>
						<span class="" v-if="scope.row.type==2">{{$t('accountList.type2')}}</span>
					</template>
				</el-table-column>	
						
				
				
				<el-table-column align="center" prop="status" width="90" :label="$t('accountList.isFp')">
					<template slot-scope="scope">
						<span v-if="scope.row.type==1">-</span>
						<el-button v-if="scope.row.type==2"
							:type="scope.row.status ? 'success' : 'danger'" 
							size="mini"
							@click="changeStatus(scope.row,'status')"
							plain>{{scope.row.status ? $t('accountList.yes') : $t('accountList.no')}}
						</el-button>
					</template>
				</el-table-column>			
				<el-table-column align="center" prop="account_status" width="100" :label="$t('accountList.account_status')">
					<template slot-scope="scope">
						<!-- <el-button 
							:type="scope.row.account_status ? 'success' : 'danger'" 
							size="mini"
							@click="changeStatus(scope.row,'account_status')"
							plain>{{scope.row.account_status==1 ? $t('accountList.zc') : $t('accountList.yc')}}
						</el-button> -->
						
						<el-dropdown v-if="layout.user.type==1" @command="changeAcStatus">
						  <el-button  size="mini" :type="getBtnType(scope.row.account_status)" plain>
						    
							<span v-if="scope.row.account_status==1">{{$t('accountList.zc')}}</span>
							<span v-if="scope.row.account_status==0">{{$t('accountList.yc')}}</span>
							<span v-if="scope.row.account_status==2">{{$t('accountList.dy')}}</span>
							<span v-if="scope.row.account_status==3">{{$t('accountList.zf')}}</span>
							<i class="el-icon-arrow-down el-icon--right"></i>
						  </el-button>
						  <el-dropdown-menu slot="dropdown">
						   
						    <el-dropdown-item :disabled="scope.row.account_status==1?true:false" :command="{ id: scope.row.id, status: 1 }">{{$t('accountList.zc')}}</el-dropdown-item>
						    <el-dropdown-item :disabled="scope.row.account_status==0?true:false" :command="{ id: scope.row.id, status: 0 }">{{$t('accountList.yc')}}</el-dropdown-item>
						    <el-dropdown-item :disabled="scope.row.account_status==2?true:false" :command="{ id: scope.row.id, status: 2 }">{{$t('accountList.dy')}}</el-dropdown-item>
						    <el-dropdown-item :disabled="scope.row.account_status==3?true:false" :command="{ id: scope.row.id, status: 3 }">{{$t('accountList.zf')}}</el-dropdown-item>
						  </el-dropdown-menu>
						</el-dropdown>
						<el-button v-else size="mini" :type="getBtnType(scope.row.account_status)" plain disabled>
							<span v-if="scope.row.account_status==1">{{$t('accountList.zc')}}</span>
							<span v-if="scope.row.account_status==0">{{$t('accountList.yc')}}</span>
							<span v-if="scope.row.account_status==2">{{$t('accountList.dy')}}</span>
							<span v-if="scope.row.account_status==3">{{$t('accountList.zf')}}</span>
						</el-button>
					</template>
				</el-table-column>
				
				<el-table-column align="center" prop="get_status" :label="$t('accountList.getType')">
					<template slot-scope="scope">
						<span  v-if="scope.row.get_status==0">{{$t('accountList.noGet')}}</span>
						<span class="text-success" v-if="scope.row.get_status==1">{{$t('accountList.yesGet')}}</span>
						<span class="text-danger" v-if="scope.row.get_status==2">{{$t('accountList.expireGet')}}</span>
					</template>
				</el-table-column>
				
				
					<el-table-column width="110" align="center" prop="api_type" :label="$t('accountList.api_type')">
						<template slot-scope="scope">
							
							<span v-if="scope.row.type==1">-</span>
							<template v-else>
								<span  v-if="scope.row.api_type==1">{{$t('accountList.api_type1')}}</span>
								<span  v-if="scope.row.api_type==2">{{$t('accountList.api_type2')}}</span>
							</template>
						</template>
					</el-table-column>

					<el-table-column width="100" align="center" prop="pay_type" :label="$t('accountList.payType')">
						<template slot-scope="scope">
							<span>{{ scope.row.pay_type==2 ? $t('accountList.payType2') : $t('accountList.payType1') }}</span>
						</template>
					</el-table-column>

					<el-table-column width="110" align="center" prop="prepay_balance" label="预付余额">
						<template slot-scope="scope">
							<span class="text_chengse">{{scope.row.prepay_balance || '0.00'}}</span>
						</template>
					</el-table-column>
					
					
				
				
				
				
				
				
				<el-table-column width="100" align="center" prop="odds" :label="$t('userList.odds')">
				
				</el-table-column>
				
				<el-table-column align="center" width="140" prop="user_name" :label="$t('accountList.getUser')">
					<template slot-scope="scope">
						<el-link @click="layout.openUserInfo(scope.row.uid)" type="primary" class="text_chengse">{{scope.row.user_name}}</el-link>
						
					</template>
				</el-table-column>
			
				
				<el-table-column align="center" prop="money" :label="$t('accountList.money')">
					<template slot-scope="scope">
						{{scope.row.money_type==1?$t('accountList.all'):scope.row.money}}
					</template>
				</el-table-column>
				
				<el-table-column width="100" align="center" prop="use_money" :label="$t('accountList.useMoney')">
					<template slot-scope="scope">
						<span class="">{{scope.row.use_money}}</span>
					</template>
				</el-table-column>
				
				<el-table-column width="100" align="center" prop="need_money" :label="$t('accountList.needMoney')">
					<template slot-scope="scope">
						<span class="text_chengse">{{scope.row.need_money}}</span>
					</template>
				</el-table-column>
				
				
				<el-table-column align="center" width="200" prop="parent_username" :label="$t('accountList.parent')">
				
				</el-table-column>
				
				<el-table-column align="center" width="200" prop="parent_username" :label="$t('accountList.acMoney')">
					<template slot-scope="scope">
						<i v-if="scope.row.balance_type==2" class="text_chengse mr-1 iconfont icon-rmb-full"></i>
						<span class="text_chengse">{{scope.row.balance_other}}</span>
					</template>
				</el-table-column>
				
				
				<el-table-column v-if="layout.user.type==1" align="center" width="200" prop="remark" :label="$t('userList.remark')">
					<template slot-scope="scope">
					<el-tooltip class="item" effect="light" :content="scope.row.remark" placement="top" >
					  <span class="ellipsis-text">{{ scope.row.remark }}</span>
					 
					</el-tooltip>
					
				
					</template>
				</el-table-column>
				<el-table-column align="center" width="100" prop="user_remark1" :label="$t('accountList.user_remark1')">
				</el-table-column>
				<el-table-column align="center" width="100" prop="user_remark2" :label="$t('accountList.user_remark2')">
				</el-table-column>	
				
				
				
				
				
				<el-table-column align="center" width="110" prop="warn_num" label="余额预警额度">
				</el-table-column>
				
				
				
				
				<el-table-column align="center" width="180" prop="create_time" :label="$t('adminList.createTime')">
				</el-table-column>
				
				<el-table-column align="center" width="180" prop="get_time" :label="$t('accountList.getTime')">
				</el-table-column>
				
				
				<el-table-column align="center"  prop="pro_name" :label="$t('accountList.focus')">
				</el-table-column>
				
				
				<el-table-column align="center"  prop="pro_name" :label="$t('model.log')">
					<template slot-scope="scope">
						<el-link @click="checkLog(scope.row.id)" type="info">{{$t('accountList.check')}}</el-link>
					</template>
				</el-table-column>
				
		
				<el-table-column :width="layout.user.type==1?270:80" fixed="right" prop="id" align="center" :label="$t('adminList.operation')">
					<template slot-scope="scope">
						<el-button-group>
							<el-button v-auth="'edit'+auth_val" :disabled="scope.row.type==1" @click="getToUser(scope.row.id)"  size="mini" plain type="success">{{$t('accountList.fp')}}</el-button>
							<el-button v-if="layout.user.type==1 && scope.row.type==2 && scope.row.pay_type==2" size="mini" plain type="warning" v-auth="'edit'+auth_val" @click="openPrepayModel(scope.row)">预充值</el-button>
							<el-button v-if="layout.user.type==1" size="mini" plain type="primary" v-auth="'edit'+auth_val" @click="openModel(scope.row)">{{$t('adminList.operation')}}</el-button>
							<el-button v-if="layout.user.type==1" size="mini" plain type="danger" v-auth="'del'+auth_val" @click="deleteItem(scope.row)">{{$t('system.delete')}}</el-button>
							
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>



		<el-footer
		  class="d-flex border-top bg-white align-items-center px-0 position-fixed"
		  :style="{ bottom: '0', left: computedLeft, right: '0', zIndex: '100' }"
		  >
		   <div style="flex: 1;" class="px-2">
		    <el-pagination
		    :current-page="page.current"
		    :page-sizes="page.sizes"
		    :page-size="page.size"
		    @size-change="handleSizeChange"
		    @current-change="handleCurrentChange"
		    background
		    :layout="layout.is_phone ? 'total, prev, pager, next, jumper' : 'total, prev, pager, next, sizes, jumper'"
		    :total="page.total"
		    />
		   </div>
		  </el-footer>

		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('accountList.editAccount') : $t('accountList.addAccount')"
			:visible.sync="createModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				<!-- <el-form-item :label="$t('adminList.avatar')" prop="icon">
					<el-upload
						name="file"
						class="avatar-uploader"
						action="/admin/image/uploadNew"
						:headers="{token:$store.state.user.token}"
						:data="{type:'userHead'}"
						:show-file-list="false"
						:on-success="handleAvatarSuccess"
						:before-upload="beforeAvatarUpload">
						<img v-if="form.icon" :src="form.icon" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item> -->
				
				
				<el-form-item :label="$t('accountList.cloudName')" prop="cloud_id">
					<el-select @change="getMainAccount" :disabled="editIndex > -1 && layout.user.type!=1" v-model="form.cloud_id" size="small" filterable :placeholder="$t('system.select')">
					
						<el-option v-for="item in agentData.cloud" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
				
				<el-form-item label="供应商" prop="supplier_id">
					<el-select  :disabled="editIndex > -1 && layout.user.type!=1" v-model="form.supplier_id" size="small" filterable :placeholder="$t('system.select')">
					
						<el-option v-for="item in agentData.provider_supplier" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
				
				<el-form-item :label="$t('new1.sup')" prop="sup_id">
					<el-select  :disabled="editIndex > -1 && layout.user.type!=1" v-model="form.sup_id" size="small" filterable :placeholder="$t('system.select')">
					
						<el-option v-for="item in agentData.sup" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
				
			
				<!-- <el-form-item :label="$t('adminList.belongTo')" prop="rule_id">
					<el-select v-model="form.rule_id" size="small" filterable :placeholder="$t('adminList.select')" style="width: 85%;">
						<el-option v-for="item in rule_list" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item> -->
				<el-form-item :label="$t('accountList.ac_id')" prop="ac_id">
					<el-input v-model="form.ac_id" :placeholder="$t('accountList.ac_id')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				<el-form-item :label="$t('adminList.loginName')" prop="username">
					<el-input  v-model="form.username"  :placeholder="$t('adminList.loginName')" clearable size="small" style="width: 85%;" auto-complete="new-password"></el-input>
				</el-form-item>
				<el-form-item :label="$t('adminList.loginPassword')" prop="password">
					<el-input v-model="form.password" show-password :placeholder="$t('adminList.loginPassword')" size="small" auto-complete="new-password" style="width: 85%;"></el-input>
				</el-form-item>
				
				<el-form-item :label="$t('accountList.other_id')" prop="email_pass">
					<el-input v-model="form.other_id"  :placeholder="$t('accountList.other_id')" size="small" auto-complete="new-password" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				<el-form-item :label="$t('accountList.email_pass')" prop="email_pass">
					<el-input v-model="form.email_pass" show-password :placeholder="$t('accountList.email_pass')" size="small" auto-complete="new-password" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				<el-form-item   :label="$t('accountList.type')">
					<el-radio-group  :disabled="editIndex > -1" v-model="form.type" size="small">
						<el-radio :label="1" border>{{$t('accountList.type1')}}</el-radio>
						<el-radio :label="2" border>{{$t('accountList.type2')}}</el-radio>
					</el-radio-group>
				</el-form-item>
				
				
				<el-form-item v-if="form.type==2 && editIndex<=0" :label="$t('accountList.type1')" prop="parent">
					<el-select @change="getMainAccount" :disabled="editIndex > -1" v-model="form.parent" size="small" filterable :placeholder="$t('system.select')">
					
						<el-option v-for="item in agentData.account" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
				
				
				
				
				<el-form-item v-if="form.type==2 " :label="$t('accountList.api_type')">
					<el-radio-group   v-model="form.api_type" size="small">
						<el-radio :label="1" border>{{$t('accountList.api_type1')}}</el-radio>
						<el-radio :label="2" border>{{$t('accountList.api_type2')}}</el-radio>
					</el-radio-group>
				</el-form-item>
				
				<el-form-item v-if="form.api_type==1" :label="$t('accountList.keyId')" prop="keyId">
					<el-input v-model="form.access_key_id" :placeholder="$t('accountList.p_keyId')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				<el-form-item v-if="form.api_type==1" :label="$t('accountList.secret')" prop="secret">
					<el-input v-model="form.secret_access_key" :placeholder="$t('accountList.p_secret')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				
				
				
				
				<el-form-item :label="$t('accountList.focus')" prop="focus">
					<el-select  v-model="form.focus" size="small" filterable :placeholder="$t('system.select')">
					<el-option  :label="$t('status.all')" :value="0">
					</el-option>
						<el-option v-for="item in agentData.product" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
					<el-form-item :label="$t('userList.odds')" prop="odds">
						<el-input v-model="form.odds" :placeholder="$t('userList.odds')" clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>

					<el-form-item :label="$t('accountList.payType')">
						<el-radio-group v-model="form.pay_type" size="small">
							<el-radio :label="1" border>{{$t('accountList.payType1')}}</el-radio>
							<el-radio :label="2" border>{{$t('accountList.payType2')}}</el-radio>
						</el-radio-group>
					</el-form-item>
					
					<el-form-item label="余额预警额度" prop="warn_num">
						<el-input v-model="form.warn_num" placeholder="" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				<el-form-item :label="$t('accountList.money')">
					<el-radio-group @input="changeMoneyType" v-model="form.money_type" size="small">
						<el-radio :label="1" border>{{$t('accountList.all')}}</el-radio>
						<el-radio :label="2" border>{{$t('accountList.other')}}</el-radio>
					</el-radio-group>
				</el-form-item>
				
				
				
				
				<el-form-item v-if="form.money_type==2" :label="$t('accountList.money')" prop="money">
					<el-input v-model="form.money" type="number" :placeholder="$t('userList.quota')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
			
				
				
				<el-form-item :label="$t('userList.remark')" prop="remark">
					<el-input v-model="form.remark" :placeholder="$t('userList.remark')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				
				
				
				
				<el-form-item :label="$t('accountList.isFp')">
					<el-radio-group v-model="form.status" size="small">
						<el-radio :label="1" border>{{$t('accountList.yes')}}</el-radio>
						<el-radio :label="0" border>{{$t('accountList.no')}}</el-radio>
					</el-radio-group>
				</el-form-item>
				
				
				
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button :loading="layout.loading" :disabled="layout.loading" type="primary" @click="submit">{{$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>

		<el-dialog :close-on-click-modal="false"
			title="预充值"
			:visible.sync="prepayModel"
			top="6vh"
			custom-class="prepay-dialog"
			:width="layout.is_phone?'94%':'720px'"
			:append-to-body="true">
			<el-form :rules="prepayRules" ref="prepayForm" :model="prepayForm" :label-width="layout.is_phone?'80px':'100px'">
				<el-form-item label="云账号">
					<span>{{ prepayForm.ac_id }}</span>
					<el-tag type="warning" size="mini" class="ml-1">预付费</el-tag>
				</el-form-item>
				<el-form-item label="累计预充值">
					<div class="prepay-summary-row">
						<span class="prepay-total">{{ formatPrepayMoney(prepaySummary.total_recharge) }}</span>
						<span class="prepay-sub">已支付：<span>{{ formatPrepayMoney(prepaySummary.paid_recharge) }}</span></span>
						<span class="prepay-sub">未支付：<span>{{ formatPrepayMoney(prepaySummary.unpaid_recharge) }}</span></span>
						<el-button type="text" size="mini" @click="openPrepayDetailModel">查看明细</el-button>
					</div>
				</el-form-item>
				<el-form-item label="支付状态" prop="prepay_status">
					<el-radio-group v-model="prepayForm.prepay_status" size="small">
						<el-radio :label="0" border>未支付</el-radio>
						<el-radio :label="1" border>已支付</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="充值月份" prop="date">
					<el-date-picker
						v-model="prepayForm.date"
						type="month"
						value-format="yyyy-MM-dd"
						size="small"
						@change="getPrepaySummary"
						placeholder="请选择充值月份">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="所选月预充值">
					<div class="prepay-summary-row">
						<span class="prepay-total">{{ formatPrepayMoney(prepaySummary.month_recharge) }}</span>
						<span class="prepay-sub">已支付：<span>{{ formatPrepayMoney(prepaySummary.month_paid_recharge) }}</span></span>
						<span class="prepay-sub">未支付：<span>{{ formatPrepayMoney(prepaySummary.month_unpaid_recharge) }}</span></span>
					</div>
				</el-form-item>
				<el-form-item label="调整金额" prop="money">
					<el-input v-model="prepayForm.money" type="number" clearable size="small" placeholder="正数增加，负数扣减"></el-input>
				</el-form-item>
				<el-form-item label="备注">
					<el-input v-model="prepayForm.remark" clearable size="small" placeholder="预充值"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="prepayModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button :loading="prepayLoading" :disabled="prepayLoading" type="primary" @click="submitPrepay">确认</el-button>
			</div>
		</el-dialog>

		<el-dialog :close-on-click-modal="false"
			title="预充值明细"
			:visible.sync="prepayDetailModel"
			top="6vh"
			custom-class="prepay-detail-dialog"
			:width="layout.is_phone?'94%':'760px'"
			:append-to-body="true">
				<el-table :data="prepaySummary.detail_list || []" border stripe size="small" style="width: 100%">
				<el-table-column align="center" prop="prepay_status_text" label="支付状态" width="100">
					<template slot-scope="scope">
						<el-tag :type="scope.row.prepay_status==1 ? 'success' : 'info'" size="mini">{{ scope.row.prepay_status_text || (scope.row.prepay_status==1 ? '已支付' : '未支付') }}</el-tag>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="month" label="充值月份" width="110"></el-table-column>
				<el-table-column align="center" prop="create_time_text" label="操作时间" width="180"></el-table-column>
				<el-table-column align="center" prop="money" label="金额" width="120">
					<template slot-scope="scope">
						<span class="text_chengse">{{ formatPrepayMoney(scope.row.money) }}</span>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="remark" label="备注"></el-table-column>
			</el-table>
			<div slot="footer" class="dialog-footer">
				<el-button @click="prepayDetailModel = false">{{$t('cdnd.close')}}</el-button>
			</div>
		</el-dialog>
		
		<el-dialog :close-on-click-modal="false"
			title="供应商管理"
			:visible.sync="providerSupplierManageModel"
			top="4vh"
			custom-class="provider-supplier-dialog"
			:width="layout.is_phone?'95%':'920px'"
			:append-to-body="true">
			<div class="mb-2 provider-supplier-toolbar">
				<el-button size="small" type="primary" @click="openProviderSupplierForm(false)">新增供应商</el-button>
				<el-input size="small" v-model="providerSupplierSearch.name" placeholder="搜索供应商名称" clearable style="width:220px;margin-left:10px" @change="getProviderSupplierList"></el-input>
				<el-select size="small" v-model="providerSupplierSearch.type" placeholder="供应商类型" clearable style="width:140px;margin-left:10px" @change="getProviderSupplierList">
					<el-option label="一级供应商" :value="1"></el-option>
					<el-option label="二级供应商" :value="2"></el-option>
				</el-select>
			</div>
			<div class="provider-supplier-table-wrap">
				<el-table :data="providerSupplierList" style="width:100%;min-width:720px">
					<el-table-column align="center" prop="id" label="ID" width="70"></el-table-column>
					<el-table-column align="center" prop="name" label="供应商" min-width="220" show-overflow-tooltip class-name="provider-supplier-nowrap"></el-table-column>
					<el-table-column align="center" prop="sup_no" label="供应商编号" width="180" show-overflow-tooltip class-name="provider-supplier-nowrap"></el-table-column>
					<el-table-column align="center" prop="type" label="供应商类型" width="120">
						<template slot-scope="scope">
							{{ Number(scope.row.type || 1) === 2 ? '二级供应商' : '一级供应商' }}
						</template>
					</el-table-column>
					<el-table-column align="center" prop="status" label="状态" width="100">
						<template slot-scope="scope">
							<el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0" @change="changeProviderSupplierStatus(scope.row)"></el-switch>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="sort" label="排序" width="80"></el-table-column>
					<el-table-column align="center" label="操作" width="180" class-name="provider-supplier-actions">
						<template slot-scope="scope">
							<el-button size="mini" type="primary" plain @click="openProviderSupplierForm(scope.row)">编辑</el-button>
							<el-button size="mini" type="danger" plain @click="delProviderSupplier(scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="mt-2 text-right provider-supplier-pagination">
				<el-pagination
					:current-page="providerSupplierPage.current"
					:page-sizes="providerSupplierPage.sizes"
					:page-size="providerSupplierPage.size"
					@size-change="handleProviderSupplierSizeChange"
					@current-change="handleProviderSupplierCurrentChange"
					background
					layout="total, prev, pager, next, sizes, jumper"
					:total="providerSupplierPage.total" />
			</div>
		</el-dialog>

		<el-dialog :close-on-click-modal="false"
			:title="providerSupplierEditIndex > 0 ? '编辑供应商' : '新增供应商'"
			:visible.sync="providerSupplierFormModel"
			:width="layout.is_phone?'90%':'460px'"
			:append-to-body="true">
			<el-form :model="providerSupplierForm" label-width="100px">
				<el-form-item label="供应商名称">
					<el-input v-model="providerSupplierForm.name" clearable></el-input>
				</el-form-item>
				<el-form-item label="供应商类型">
					<el-radio-group v-model="providerSupplierForm.type">
						<el-radio-button :label="1">一级供应商</el-radio-button>
						<el-radio-button :label="2">二级供应商</el-radio-button>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="排序">
					<el-input-number v-model="providerSupplierForm.sort" :min="0" controls-position="right"></el-input-number>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="providerSupplierFormModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button type="primary" @click="saveProviderSupplier">{{$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>

		<el-dialog :close-on-click-modal="false"
			title="子供应商管理"
			:visible.sync="subSupplierManageModel"
			top="4vh"
			custom-class="provider-supplier-dialog"
			:width="layout.is_phone?'95%':'1040px'"
			:append-to-body="true">
			<div class="mb-2 provider-supplier-toolbar">
				<el-button size="small" type="primary" @click="openSubSupplierForm(false)">新增子供应商</el-button>
				<el-input size="small" v-model="subSupplierSearch.name" placeholder="搜索子供应商名称" clearable style="width:220px;margin-left:10px" @change="getSubSupplierList"></el-input>
			</div>
			<div class="provider-supplier-table-wrap">
				<el-table :data="subSupplierList" style="width:100%;min-width:900px">
					<el-table-column align="center" prop="id" label="ID" width="70"></el-table-column>
					<el-table-column align="center" prop="name" label="子供应商" min-width="180" show-overflow-tooltip class-name="provider-supplier-nowrap"></el-table-column>
					<el-table-column align="center" prop="sup_no" label="子供应商编号" width="160" show-overflow-tooltip class-name="provider-supplier-nowrap"></el-table-column>
					<el-table-column align="center" prop="phone" label="电话" width="140" show-overflow-tooltip class-name="provider-supplier-nowrap"></el-table-column>
					<el-table-column align="center" prop="email" label="邮箱" min-width="180" show-overflow-tooltip class-name="provider-supplier-nowrap"></el-table-column>
					<el-table-column align="center" prop="local" label="地址" min-width="180" show-overflow-tooltip class-name="provider-supplier-nowrap"></el-table-column>
					<el-table-column align="center" prop="status" label="状态" width="100">
						<template slot-scope="scope">
							<el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0" @change="changeSubSupplierStatus(scope.row)"></el-switch>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="sort" label="排序" width="80"></el-table-column>
					<el-table-column align="center" label="操作" width="180" class-name="provider-supplier-actions">
						<template slot-scope="scope">
							<el-button size="mini" type="primary" plain @click="openSubSupplierForm(scope.row)">编辑</el-button>
							<el-button size="mini" type="danger" plain @click="delSubSupplier(scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="mt-2 text-right provider-supplier-pagination">
				<el-pagination
					:current-page="subSupplierPage.current"
					:page-sizes="subSupplierPage.sizes"
					:page-size="subSupplierPage.size"
					@size-change="handleSubSupplierSizeChange"
					@current-change="handleSubSupplierCurrentChange"
					background
					layout="total, prev, pager, next, sizes, jumper"
					:total="subSupplierPage.total" />
			</div>
		</el-dialog>

		<el-dialog :close-on-click-modal="false"
			:title="subSupplierEditIndex > 0 ? '编辑子供应商' : '新增子供应商'"
			:visible.sync="subSupplierFormModel"
			:width="layout.is_phone?'90%':'520px'"
			:append-to-body="true">
			<el-form :model="subSupplierForm" label-width="110px">
				<el-form-item label="子供应商名称">
					<el-input v-model="subSupplierForm.name" clearable></el-input>
				</el-form-item>
				<el-form-item label="电话">
					<el-input v-model="subSupplierForm.phone" clearable></el-input>
				</el-form-item>
				<el-form-item label="邮箱">
					<el-input v-model="subSupplierForm.email" clearable></el-input>
				</el-form-item>
				<el-form-item label="地址">
					<el-input v-model="subSupplierForm.local" clearable></el-input>
				</el-form-item>
				<el-form-item label="排序">
					<el-input-number v-model="subSupplierForm.sort" :min="0" controls-position="right"></el-input-number>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="subSupplierFormModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button type="primary" @click="saveSubSupplier">{{$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>
		
		
		<el-dialog :close-on-click-modal="false"
			:title="$t('accountList.editStatusRemark')"
			:visible.sync="remarkModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules_remark" ref="form_remark" :model="form_remark" :label-width="layout.is_phone?'80px':'100px'">
		
				
				<el-form-item :label="$t('accountList.remark')" prop="remark">
					<el-input v-model="form_remark.remark" :placeholder="$t('accountList.remark')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				
			</el-form>
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="remarkModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button :loading="layout.loading" :disabled="layout.loading" type="primary" @click="submitRemark">{{$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				remarkModel:false,
				createModel: false,
				editIndex: -1,
				
				//搜索數据
				from: {
					name: '',
					username:'',
					parentAcid:"",
					parentID:"",
					supplier_id:-1,
					sup_id:-1,
					status:-1,
					get_status:-1,
					account_status:-1,
					type:-1,
					cloud_id:-1,
					ac_id:'',
					time:[],
				},
				auth_val: 'Account',
				odds:0,
				preUrl: "data/accountList", //列表地址
				delAllUrl: "data/delAccountAll", //批量删除地址
				delUrl: "data/delAccount", //删除單条地址
				addUrl: "data/addAccount", //添加/修改地址
				editStatusUrl:"data/editStatusAccount",//修改狀態地址
				agentData:{
					cloud: [],
					product: [],
					provider_supplier: [],
					sup: [],
					user: [],
					account: []
				},
				tableData: [],
				form: {},
				prepayModel: false,
				prepayDetailModel: false,
				prepayLoading: false,
				prepayForm: {
					account_id: '',
					ac_id: '',
					date: '',
					money: '',
					prepay_status: 0,
					remark: '预充值'
				},
				prepaySummary: {
					total_recharge: '0.00',
					paid_recharge: '0.00',
					unpaid_recharge: '0.00',
					month_recharge: '0.00',
					month_paid_recharge: '0.00',
					month_unpaid_recharge: '0.00',
					detail_list: []
				},
				providerSupplierManageModel: false,
				providerSupplierFormModel: false,
				providerSupplierEditIndex: -1,
				providerSupplierList: [],
				providerSupplierSearch: {
					name: '',
					type: ''
				},
				providerSupplierPage: {
					current: 1,
					sizes: [10, 20, 50, 100],
					size: 10,
					total: 0
				},
				providerSupplierForm: {
					id: 0,
					name: '',
					type: 1,
					sort: 1,
					status: 1
				},
				subSupplierManageModel: false,
				subSupplierFormModel: false,
				subSupplierEditIndex: -1,
				subSupplierList: [],
				subSupplierSearch: {
					name: ''
				},
				subSupplierPage: {
					current: 1,
					sizes: [10, 20, 50, 100],
					size: 10,
					total: 0
				},
				subSupplierForm: {
					id: 0,
					name: '',
					phone: '',
					email: '',
					local: '',
					sort: 1,
					status: 1
				},
				accountExcelLoading: false,
				form_remark:{
				},
				rules_remark:{
					remark: [{
						required: true,
						message: this.$t('accountList.inpStatusRemark'),
						trigger: 'blur',
					}],
				},
				prepayRules: {
					date: [{
						required: true,
						message: '请选择充值月份',
						trigger: 'change'
					}],
					money: [{
						required: true,
						message: '请输入调整金额',
						trigger: 'blur'
					}],
				},
				rules: {
					name: [{
						required: true,
						message: this.$t('userList.nameRequired'),
						trigger: 'blur',
					}],
					username: [{
						required: true,
						message: this.$t('adminList.usernameRequired'),
						trigger: 'blur',
					}],
					password: [{
						required: true,
						message: this.$t('accountList.inpPass'),
						trigger: 'blur'
					}],
					cloud_id: [{
						required: true,
						message: this.$t('accountList.selCloud'),
						trigger: 'blur',
					}],
					supplier_id:[{
						required: true,
						message: '请选择供应商',
						trigger: 'blur',
					}],
					parent: [{
						required: true,
						message: this.$t('accountList.selMainAc'),
						trigger: 'blur',
					}],
					ac_id: [{
						required: true,
						message: this.$t('accountList.inp_ac_id'),
						trigger: 'blur',
					}],
					odds: [{
						required: true,
						message: this.$t('userList.inpOdds'),
						trigger: 'blur',
					}],
					sup_id:[{
						required: true,
						message: this.$t('new1.selSup'),
						trigger: 'blur',
					}],
				},
				rule_list: [],
				check_img_list:[]
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			this.commonList('account');
		},
		methods: {
			downAccountExcel(){
				this.accountExcelLoading = true
				this.axios.post('/admin/data/accountExcel', {
					search: this.from,
					prop: this.prop,
					sort: this.sort == 'ascending' ? 'asc' : 'desc',
					cloud_id: this.cloud_id
				}, {
					token: true
				}).then(res => {
					let all = res.data
					let list = all.data.list
					const link = document.createElement('a')
					link.href = list
					link.download = ''
					link.target = '_blank'
					document.body.appendChild(link)
					link.click()
					document.body.removeChild(link)
				}).catch(() => {
					this.$message.error(this.$t('system.openFailed'))
				}).finally(() => {
					this.accountExcelLoading = false
				})
			},
			defaultPrepayMonth(){
				const date = new Date()
				date.setDate(1)
				date.setMonth(date.getMonth() - 1)
				const year = date.getFullYear()
				const month = String(date.getMonth() + 1).padStart(2, '0')
				const value = `${year}-${month}-01`
				return value < '2026-06-01' ? '2026-06-01' : value
			},
			formatPrepayMoney(value){
				const money = Number(value || 0)
				return Number.isFinite(money) ? money.toFixed(2) : '0.00'
			},
			getPrepaySummary(){
				if(!this.prepayForm.account_id || !this.prepayForm.date){
					this.prepaySummary = {
						total_recharge: '0.00',
						paid_recharge: '0.00',
						unpaid_recharge: '0.00',
						month_recharge: '0.00',
						month_paid_recharge: '0.00',
						month_unpaid_recharge: '0.00',
						detail_list: []
					}
					return
				}
				this.axios.post('/admin/data/accountPrepayRechargeSummary', {
					account_id: this.prepayForm.account_id,
					date: this.prepayForm.date
				}, {
					token: true
				}).then(res => {
					if(res.data.code==1){
						this.prepaySummary = res.data.data.list || {
							total_recharge: '0.00',
							paid_recharge: '0.00',
							unpaid_recharge: '0.00',
							month_recharge: '0.00',
							month_paid_recharge: '0.00',
							month_unpaid_recharge: '0.00',
							detail_list: []
						}
					}
				})
			},
			openPrepayDetailModel(){
				this.prepayDetailModel = true
				this.getPrepaySummary()
			},
			openPrepayModel(row){
				this.prepayForm = {
					account_id: row.id,
					ac_id: row.ac_id,
					date: this.defaultPrepayMonth(),
					money: '',
					prepay_status: 0,
					remark: '预充值'
				}
				this.prepaySummary = {
					total_recharge: '0.00',
					paid_recharge: '0.00',
					unpaid_recharge: '0.00',
					month_recharge: '0.00',
					month_paid_recharge: '0.00',
					month_unpaid_recharge: '0.00',
					detail_list: []
				}
				this.prepayModel = true
				this.getPrepaySummary()
				this.$nextTick(() => {
					if(this.$refs.prepayForm){
						this.$refs.prepayForm.clearValidate()
					}
				})
			},
			submitPrepay(){
				this.$refs.prepayForm.validate(res => {
					if(!res){
						return
					}
					if(Number(this.prepayForm.money || 0) === 0){
						this.$message.error('调整金额不能为 0')
						return
					}
					if(this.prepayForm.date < '2026-06-01'){
						this.$message.error('预充值只支持 2026-06 及之后月份')
						return
					}
					this.prepayLoading = true
					this.axios.post('/admin/data/accountPrepayRecharge', this.prepayForm, {
						token: true
					}).then(res => {
						if(res.data.code==1){
							this.$message.success(res.data.msg)
							this.prepayModel = false
							this.getList()
						}
					}).finally(() => {
						this.prepayLoading = false
					})
				})
			},
			openProviderSupplierManage(){
				this.providerSupplierManageModel = true
				this.getProviderSupplierList()
			},
			getProviderSupplierList(){
				this.axios.post('/admin/data/providerSupplierList', {
					page: this.providerSupplierPage.current,
					limit: this.providerSupplierPage.size,
					search: this.providerSupplierSearch
				}, {
					token: true
				}).then(res => {
					let list = res.data.data.list
					this.providerSupplierList = list.list
					this.providerSupplierPage.total = list.total
				})
			},
			handleProviderSupplierSizeChange(val){
				this.providerSupplierPage.size = val
				this.getProviderSupplierList()
			},
			handleProviderSupplierCurrentChange(val){
				this.providerSupplierPage.current = val
				this.getProviderSupplierList()
			},
			openProviderSupplierForm(row = false){
				if(row){
					this.providerSupplierEditIndex = row.id
					this.providerSupplierForm = Object.assign({}, row)
				}else{
					this.providerSupplierEditIndex = -1
					this.providerSupplierForm = {
						id: 0,
						name: '',
						type: 1,
						sort: 1,
						status: 1
					}
				}
				this.providerSupplierFormModel = true
			},
			saveProviderSupplier(){
				let data = {
					id: this.providerSupplierEditIndex,
					name: this.providerSupplierForm.name,
					type: Number(this.providerSupplierForm.type || 1),
					sort: this.providerSupplierForm.sort,
					status: this.providerSupplierForm.status
				}
				this.axios.post('/admin/data/addProviderSupplier', data, {
					token: true
				}).then(res => {
					if(res.data.code==1){
						this.$message.success(res.data.msg)
						this.providerSupplierFormModel = false
						this.getProviderSupplierList()
						this.commonList('account')
					}
				})
			},
			changeProviderSupplierStatus(row){
				this.axios.post('/admin/data/editStatusProviderSupplier', {
					id: row.id,
					status: row.status
				}, {
					token: true
				}).then(res => {
					if(res.data.code==1){
						this.$message.success(res.data.msg)
						this.commonList('account')
					}
				})
			},
			delProviderSupplier(row){
				this.$confirm(this.$t('system.yesOrNoDel'), this.$t('system.prompt'), {
					confirmButtonText: this.$t('system.delete'),
					cancelButtonText: this.$t('system.cancel'),
					type: 'warning'
				}).then(() => {
					this.axios.post('/admin/data/delProviderSupplier', {
						id: row.id
					}, {
						token: true
					}).then(res => {
						if(res.data.code==1){
							this.$message.success(res.data.msg)
							this.getProviderSupplierList()
							this.commonList('account')
						}
					})
				})
			},
			openSubSupplierManage(){
				this.subSupplierManageModel = true
				this.getSubSupplierList()
			},
			getSubSupplierList(){
				this.axios.post('/admin/data/subSupplierList', {
					page: this.subSupplierPage.current,
					limit: this.subSupplierPage.size,
					search: this.subSupplierSearch
				}, {
					token: true
				}).then(res => {
					let list = res.data.data.list
					this.subSupplierList = list.list
					this.subSupplierPage.total = list.total
				})
			},
			handleSubSupplierSizeChange(val){
				this.subSupplierPage.size = val
				this.getSubSupplierList()
			},
			handleSubSupplierCurrentChange(val){
				this.subSupplierPage.current = val
				this.getSubSupplierList()
			},
			openSubSupplierForm(row = false){
				if(row){
					this.subSupplierEditIndex = row.id
					this.subSupplierForm = Object.assign({}, row)
				}else{
					this.subSupplierEditIndex = -1
					this.subSupplierForm = {
						id: 0,
						name: '',
						phone: '',
						email: '',
						local: '',
						sort: 1,
						status: 1
					}
				}
				this.subSupplierFormModel = true
			},
			saveSubSupplier(){
				let data = {
					id: this.subSupplierEditIndex,
					name: this.subSupplierForm.name,
					phone: this.subSupplierForm.phone,
					email: this.subSupplierForm.email,
					local: this.subSupplierForm.local,
					sort: this.subSupplierForm.sort,
					status: this.subSupplierForm.status
				}
				this.axios.post('/admin/data/addSubSupplier', data, {
					token: true
				}).then(res => {
					if(res.data.code==1){
						this.$message.success(res.data.msg)
						this.subSupplierFormModel = false
						this.getSubSupplierList()
						this.commonList('account')
					}
				})
			},
			changeSubSupplierStatus(row){
				this.axios.post('/admin/data/editStatusSubSupplier', {
					id: row.id,
					status: row.status
				}, {
					token: true
				}).then(res => {
					if(res.data.code==1){
						this.$message.success(res.data.msg)
						this.commonList('account')
					}
				})
			},
			delSubSupplier(row){
				this.$confirm(this.$t('system.yesOrNoDel'), this.$t('system.prompt'), {
					confirmButtonText: this.$t('system.delete'),
					cancelButtonText: this.$t('system.cancel'),
					type: 'warning'
				}).then(() => {
					this.axios.post('/admin/data/delSubSupplier', {
						id: row.id
					}, {
						token: true
					}).then(res => {
						if(res.data.code==1){
							this.$message.success(res.data.msg)
							this.getSubSupplierList()
							this.commonList('account')
						}
					})
				})
			},
			getBtnType(status){
				if(status==1){
					return 'success';
				}else if(status==0){
					return 'danger';
				}else if(status==3){
					return 'warning';
				}else{
					return 'info';
				}
			},
			changeAcStatus(data){
				this.form_remark = {
					id:data.id,
					status:data.status,
					remark:''
				}
			
				this.remarkModel = true
			},
			submitRemark(){
				this.$refs.form_remark.validate(res => {
					
					if (res) {
						this.changeAcStatusApi(this.form_remark)
					}
				})
			},
			changeAcStatusApi(data){
				//this.layout.loading = true;
				this.axios.post(this.changeStatusUrl(), {
					id: data.id,
					remark: data.remark,
					status: data.status,
					type: 'account_status',
				}, {
					token: true,
				}).then(res => {
					let all = res.data;
					console.log(all)
					if (all.code == 1) {
						this.$message({
							message:all.msg,
							type: 'success'
						});
						let index  = this.tableData.findIndex(item=>item.id == data.id)
						this.tableData[index].account_status = data.status
						if(data.status==2){
							this.getList()
						}
					}
					this.remarkModel = false
					//this.layout.loading = false;
				}).catch(err => {
					//this.layout.loading = false;
					this.$message.error(this.$t('system.openFailed'));
				});
			},
			getMainAccount(e){
				this.commonList('account1',e);
			},
			getToUser(id){
				this.layout.getModel = true
				this.layout.getModelType = 1
				this.layout.getModelTypeId = id
			},
			checkLog(id){
				this.layout.logModel = true
				this.layout.logID = id
				this.layout.logType = 1
			},
			changePassShow(item){
				item.showPass = item.showPass==1?0:1
			},
			changePassShowEmail(item){
				item.showPassEmail = item.showPassEmail==1?0:1
			},
			changeMoneyType(e){
				if(e==1){
					this.form.money = 0
				}
				//console.log(e)
			},
			//提交
			submit() {
				// if (this.form.password != this.form.password2) {
				// 	this.$message({
				// 		message: this.$t('adminList.differentPasswords'),
				// 		type: 'error'
				// 	});
				// 	return
				// }
				this.$refs.form.validate(res => {
					// if(!this.form.headUrl){
					// 	this.$message.error(this.$t('adminList.upProfile'));
					// 	return false
					// }
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},

			// 打开模态框
			openModel(e = false) {
				// 增加
				console.log(e)
				if (!e) {
					// 初始化表單
					this.form = {
						id:0,
						cloud_id: '',
						supplier_id: '',
						focus:0,
						username: '',
						password: '',
						status: 1,
						odds: this.odds,
							warn_num:0,
							money:0,
							pay_type:1,
							type:1,
							parent:'',
						money_type:1,
						ac_id:'',
						sup_id:'',
						access_key_id:'',
						secret_access_key:'',
						api_type:1,
						other_id:'',
						email_pass:'',
						remark:''
					}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						id:e.id,
						cloud_id: e.cloud_id,
						supplier_id: e.supplier_id,
						sup_id: e.sup_id,
						focus:e.focus,
						username: e.username,
						password: e.password,
						status: e.status,
						odds: e.odds,
						type: e.type,
						ac_id: e.ac_id,
						other_id: e.other_id,
						email_pass: e.email_pass,
						parent: e.parent,
							api_type: e.api_type,
							money:e.money,
							access_key_id:'',
							secret_access_key:'',
							money_type:e.money_type,
							pay_type:e.pay_type || 1,
							warn_num:e.warn_num,
							remark:e.remark
						}
					this.editIndex = e.id
				}
				
				// 打开dialog
				this.createModel = true
			},
			//公共列表
			commonList(type,id=0) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
					id:id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					
					if(type=='account'){
						this.agentData.cloud = list.cloud
						this.agentData.product = list.product
						this.agentData.provider_supplier = list.provider_supplier
						this.agentData.sup = list.sup
						this.agentData.user = list.user || []
						this.odds = list.user_odds
					}else{
						console.log(list)
						console.log(id)
						this.agentData.account = list.account
					}
					
					
					
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.headUrl = res.encryption.data.list.url
				}
			  },
			beforeAvatarUpload(file) {
							const isJPG = file.type === 'image/jpeg';
							const isLt2M = file.size / 1024 / 1024 < 2;
					
							// if (!isJPG) {
							//   this.$message.error('上傳头像图片只能是 JPG 格式!');
							// }
							// if (!isLt2M) {
							//   this.$message.error('上傳头像图片大小不能超過 2MB!');
							// }
							return isJPG && isLt2M;
			},
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					username:'',
					parentAcid:"",
					parentID:"",
					supplier_id:-1,
					sup_id:-1,
					status:-1,
					get_status:-1,
					account_status:-1,
					type:-1,
					cloud_id:-1,
					ac_id:'',
					time:[],
				}
			
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
.custom-dialog {
  z-index: 3000!important; /* 设置更高的 z-index */
}

.prepay-dialog .el-dialog__body,
.prepay-detail-dialog .el-dialog__body {
	max-height: calc(88vh - 120px);
	overflow-y: auto;
	padding-top: 12px;
}

.prepay-dialog .el-form-item {
	margin-bottom: 18px;
}

.prepay-summary-row {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 8px 18px;
	min-height: 40px;
	line-height: 40px;
}

.prepay-total,
.prepay-sub span {
	color: #ff7f50;
	font-weight: 600;
}

.prepay-total {
	min-width: 72px;
	font-size: 16px;
}

.prepay-sub {
	color: #606266;
	white-space: nowrap;
}

.provider-supplier-dialog .el-dialog__body {
	height: calc(92vh - 116px);
	overflow: hidden;
	padding-top: 12px;
	display: flex;
	flex-direction: column;
}

.provider-supplier-toolbar {
	display: flex;
	align-items: center;
	flex: none;
	white-space: nowrap;
}

.provider-supplier-table-wrap {
	flex: 1;
	min-height: 0;
	overflow: auto;
}

.provider-supplier-pagination {
	flex: none;
	white-space: nowrap;
}

.provider-supplier-dialog .el-table .cell,
.account-provider-nowrap .cell,
.provider-supplier-nowrap .cell,
.provider-supplier-actions .cell {
	white-space: nowrap;
}

.provider-supplier-actions .cell {
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 8px;
}

.provider-supplier-actions .el-button + .el-button {
	margin-left: 0;
}
</style>
